import { Col, Layout, Menu, Row, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Step1 from "./Components/BasicInfo";
import Step2 from "./Components/VerifyInfoes";
import Step3 from "./Components/CorporateInfoes";
import MLSBanner from "assets/Images/MLSBanner.png";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetDoneSteps } from "./ClientSideStates";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";

const { Sider, Content } = Layout;
const { Text } = Typography;

const InstitutionalIndex = () => {
  const containerRef = useRef<any>(null)
  const [currentStep, setCurrentStep] = useState(0);
  const { doneStesps } = useSelector((state: RootState) => state.institutional);
  const dispatch = useDispatch();
  const { initialStoreInfoes } = useSelector(
    (state: RootState) => state.institutional
  );
  const menuItems = [
    { key: "0", label: "Doğrulama" },
    {
      key: "1",
      label: "Temel Bilgiler",
      disabled: !initialStoreInfoes?.isletmeUnvani,
    },
    {
      key: "2",
      label: "Kurumsal Bilgiler",
      disabled:
        doneStesps.includes(1) && initialStoreInfoes?.isletmeUnvani
          ? false
          : true,
    },
  ];

  useEffect(() => {
    return () => {
      dispatch(handleSetDoneSteps({ data: [] }));
    };
  }, []);

  return (
    <Row className="xl:!h-screen  mt-[30px]" gutter={[0, 0]} ref={containerRef}>
      <Col xs={24}   xl={8} xxl={6} className="!rounded-lg ">
        <Sider
          id="corporate-menu"
        
          theme="light"
          width="100%"
          className="!bg-white !h-full"
        >
          <div
            style={{
              backgroundImage: `url('${MLSBanner}')`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className="!p-4  !w-full !h-[100px] !flex items-center justify-center !mb-4"
          >
            <div className="!grid gap-2">
              <Col xs={24} className="!flex justify-center">
                <Text className="!text-xl !text-black !font-bold">
                  Sarıilanlar.com
                </Text>
              </Col>
              <Col xs={24} className="!flex justify-center">
                <Text className="!text-lg !text-black">
                  Profesyonel Avantajlara Hoş Geldiniz
                </Text>
              </Col>
            </div>
          </div>
          <ResponsiveMenu
          containerRef={containerRef}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            defaultSelectedKeys={["0"]}
            menuItems={menuItems}
            onClick={(e) => {
              if (!menuItems.find((item) => item.key === e.key)?.disabled) {
                setCurrentStep(Number(e.key));
              }
            }}
          />
        </Sider>
      </Col>

      <Col xs={24}  xl={16} xxl={18} className="  lg:!px-6 xxl:!px-16">
        <Content className=" !rounded-lg xxl:!shadow-xl  !pt-4 xl:!p-6  ">
          {(() => {
            if (currentStep === 0) {
              return <Step2 setCurrentStep={setCurrentStep} />;
            } else if (currentStep === 1) {
              return <Step1 setCurrentStep={setCurrentStep} />;
            } else if (currentStep === 2) {
              return <Step3 setCurrentStep={setCurrentStep} />;
            }
            return <></>;
          })()}
        </Content>
      </Col>
    </Row>
  );
};

export default InstitutionalIndex;
